import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface DropdownCategoryProps {
  className?: string;
}

/*
 * Style.
 */

const StyledCategoryDiv = styled.div`
  padding: 9px 12px 6px 12px;

  color: ${(p) => p.theme.greys.shade60};
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.semibold};
`;

/*
 * Component.
 */

export const DropdownCategory: FC<PropsWithChildren<DropdownCategoryProps>> = (props) => (
  <StyledCategoryDiv className={props.className}>{props.children}</StyledCategoryDiv>
);
